import { getDeposits } from "@/http/depositsApi";
import { getDepositsQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetDepositsQuery = () => {
  return useQuery({
    queryKey: getDepositsQueryKey(),
    queryFn: () => getDeposits(),
    select: (response) => response.data.data,
  });
};
